import { useToast as useChakraToast } from '@chakra-ui/react';
import { useCallback } from 'react';

/**
 * Custom hook for toast notifications
 * Provides consistent toast styling and simplified API
 */
export const useToast = () => {
  const toast = useChakraToast();

  const showToast = useCallback((options) => {
    toast({
      duration: 5000,
      isClosable: true,
      position: 'top-right',
      ...options,
    });
  }, [toast]);

  const showSuccess = useCallback((message, title = '成功') => {
    showToast({
      title,
      description: message,
      status: 'success',
    });
  }, [showToast]);

  const showError = useCallback((message, title = 'エラー') => {
    showToast({
      title,
      description: message || 'エラーが発生しました',
      status: 'error',
    });
  }, [showToast]);

  const showWarning = useCallback((message, title = '警告') => {
    showToast({
      title,
      description: message,
      status: 'warning',
    });
  }, [showToast]);

  const showInfo = useCallback((message, title = '情報') => {
    showToast({
      title,
      description: message,
      status: 'info',
    });
  }, [showToast]);

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showToast, // For custom toast options
  };
};
